/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../_chunks/dep-56ceb7ce.mjs';
import { _ as _slicedToArray } from '../_chunks/dep-fc63c737.mjs';
import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, toRefs, ref, computed, createVNode, Fragment } from 'vue';
import { StarFilledIcon } from 'tdesign-icons-vue-next';
import useVModel from '../hooks/useVModel.mjs';
import props from './props.mjs';
import '../hooks/useConfig.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import { Tooltip } from '../tooltip/index.mjs';
import { i as isArray_1 } from '../_chunks/dep-b9567f6a.mjs';
import { useConfig } from '../config-provider/useConfig.mjs';
import '../_chunks/dep-2a2a0e63.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-8d19eb1a.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-f50ac97c.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ff1c0573.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-7f2f03b4.mjs';
import '../tooltip/tooltip.mjs';
import '../_chunks/dep-219a3220.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-30c9b83d.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-f7eab885.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../tooltip/props.mjs';
import '../popup/props.mjs';
import '../popup/index.mjs';
import '../popup/popup.mjs';
import '@popperjs/core';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../_common/js/utils/set-style.mjs';
import '../popup/container.mjs';
import '../hooks/useResizeObserver.mjs';
import '../_chunks/dep-fdde96c5.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../popup/type.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';
import '../tooltip/util.mjs';
import '../tooltip/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _Rate = defineComponent({
  name: "TRate",
  props: _objectSpread({}, props),
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var renderTNodeJSX = useTNodeJSX();
    var activeColor = isArray_1(props2.color) ? props2.color[0] : props2.color;
    var defaultColor = isArray_1(props2.color) ? props2.color[1] : "var(--td-bg-color-component)";
    var _toRefs = toRefs(props2),
      inputValue = _toRefs.value,
      modelValue = _toRefs.modelValue;
    var _useVModel = useVModel(inputValue, modelValue, props2.defaultValue, props2.onChange),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      starValue = _useVModel2[0],
      setStarValue = _useVModel2[1];
    var hoverValue = ref(void 0);
    var root = ref();
    var displayValue = computed(function () {
      return Number(hoverValue.value || starValue.value);
    });
    var displayText = computed(function () {
      return props2.texts.length === 0 ? ["\u6781\u5DEE", "\u5931\u671B", "\u4E00\u822C", "\u6EE1\u610F", "\u60CA\u559C"] : props2.texts;
    });
    var RateIcon = function RateIcon(iconProps) {
      if (slots.icon !== void 0) {
        return renderTNodeJSX("icon", {
          params: iconProps
        });
      }
      return createVNode(StarFilledIcon, iconProps, null);
    };
    var getStarValue = function getStarValue(event, index) {
      if (props2.allowHalf) {
        var _root$value$getBoundi = root.value.getBoundingClientRect(),
          left = _root$value$getBoundi.left;
        var firstStar = root.value.firstChild.nextSibling;
        var _firstStar$getBoundin = firstStar.getBoundingClientRect(),
          width = _firstStar$getBoundin.width;
        var clientX = event.clientX;
        var starMiddle = width * (index - 0.5) + props2.gap * (index - 1);
        if (clientX - left >= starMiddle) return index;
        if (clientX - left < starMiddle) return index - 0.5;
      }
      return index;
    };
    var mouseEnterHandler = function mouseEnterHandler(event, index) {
      if (props2.disabled) return;
      hoverValue.value = getStarValue(event, index);
    };
    var mouseLeaveHandler = function mouseLeaveHandler() {
      if (props2.disabled) return;
      hoverValue.value = void 0;
    };
    var clickHandler = function clickHandler(event, index) {
      if (props2.disabled) return;
      setStarValue(getStarValue(event, index));
    };
    var getStarCls = function getStarCls(index) {
      if (props2.allowHalf && index + 0.5 === displayValue.value) return "".concat(classPrefix.value, "-rate__item--half");
      if (index >= displayValue.value) return "";
      if (index < displayValue.value) return "".concat(classPrefix.value, "-rate__item--full");
    };
    var _useConfig = useConfig("classPrefix"),
      classPrefix = _useConfig.classPrefix;
    return function () {
      return createVNode("div", {
        "class": "".concat(classPrefix.value, "-rate"),
        "onMouseleave": mouseLeaveHandler
      }, [createVNode("ul", {
        "class": "".concat(classPrefix.value, "-rate__list"),
        "style": {
          gap: "".concat(props2.gap, "px")
        },
        "ref": root
      }, [_toConsumableArray(Array(Number(props2.count))).map(function (_, index) {
        return createVNode("li", {
          "key": index,
          "class": ["".concat(classPrefix.value, "-rate__item"), getStarCls(index)],
          "onClick": function onClick(event) {
            return clickHandler(event, index + 1);
          },
          "onMousemove": function onMousemove(event) {
            return mouseEnterHandler(event, index + 1);
          }
        }, [props2.showText ? createVNode(Tooltip, {
          "key": index,
          "content": displayText.value[displayValue.value - 1]
        }, {
          "default": function _default() {
            return [createVNode("div", {
              "class": "".concat(classPrefix.value, "-rate__star-top")
            }, [createVNode(RateIcon, {
              "size": props2.size,
              "color": activeColor
            }, null)]), createVNode("div", {
              "class": "".concat(classPrefix.value, "-rate__star-bottom")
            }, [createVNode(RateIcon, {
              "size": props2.size,
              "color": defaultColor
            }, null)])];
          }
        }) : createVNode(Fragment, null, [createVNode("div", {
          "class": "".concat(classPrefix.value, "-rate__star-top")
        }, [createVNode(RateIcon, {
          "size": props2.size,
          "color": activeColor
        }, null)]), createVNode("div", {
          "class": "".concat(classPrefix.value, "-rate__star-bottom")
        }, [createVNode(RateIcon, {
          "size": props2.size,
          "color": defaultColor
        }, null)])])]);
      })]), props2.showText && createVNode("div", {
        "className": "".concat(classPrefix.value, "-rate__text")
      }, [displayText.value[displayValue.value - 1]])]);
    };
  }
});

export { _Rate as default };
//# sourceMappingURL=rate.mjs.map
